import '@@/styles/main.scss'

import './js/bootstrap'
import OveApp from './js/core'

// console.log('welcome to websn!')
window.OveApp = new OveApp();

window.onload = window.OveApp.init

document.addEventListener("DOMContentLoaded", function(){
  if ($('.pages').height() > 490) {
    $('.pages .opener').removeClass('d-none')
    $('.pages').removeClass('open')
  }
})
